export default {
    // 模块名称
    videoPatrol: {
        // 按钮类
        button: {
            search: 'Query',
            reset: 'Reset',
            confirm: 'Confirm',
            export: 'Export',
            cancel: 'Cancel',
            save: 'Save',
            close: 'Close',
            next: 'Next',
            conform: 'Conform',
            prompt: 'Prompt',
            whole: 'All',
            modify: 'Modify',
            disadled: 'Disabled',
            abled: 'Enabled',
            stop: 'Disabled',
            edit: 'Edit',
            view: 'view',
            delete: 'Delete'
        },
        // 文字标签类
        label: {
            patrolName: 'PatrolName',
            startTime: 'StartTime',
            endTime: 'EndTime',
            person: 'Person',
            reportSource: 'ReportSource',
            report: 'Report',
            repairReport: 'RepairReport',
            lookReport: 'LookReport',
            alarmName: 'AlarmName',
            alarmType: 'AlarmType',
            alarmLevel: 'AlarmLevel',
            alarmPlace: 'AlarmPlace',
            alarmTime: 'AlarmTime',
            workDetail: 'WorkDetail',
            workPeople: 'WorkPeople',
            workDescribe: 'WorkDescribe',
            facilityName: 'FacilityName',
            clockStatus: 'ClockStatus',
            alarmEvent: 'AlarmEvent',
            lookPicture: 'LookPicture',
            taskName: 'TaskName',
            Responsible: 'Responsible',
            planClock: 'PlanClock',
            realClock: 'RealClock',
            loseClock: 'LoseClock',
            reportRemark: 'Remark',
            alarmReport: 'Alarm Reporting',
            reportPeople: 'ReportPeople',
            level: 'Level',
            urgency: 'urgency',
            severity: 'severity',
            ordinary: 'ordinary',
            common: 'common',
            type: 'Type',
            upload: 'Upload',
            description: 'Description',
            No: 'No',
            patrolTime: 'PatrolTime',
            operate: 'Operate',
            preview: 'Preview',
            rise: 'Rise',
            drop: 'Drop',
            delete: 'Delete',
            chooseList: 'Pending list',
            finChooseList: 'Selected list',
            planName: 'Name',
            online: 'Punch',
            message: 'Notification',
            etherSearch: 'Circulation',
            times: 'Number',
            selectedAccountGroup: 'Group',
            startAndEndDate: 'Patrol cycle',
            startTimes: 'Start date',
            endTimes: 'End date',
            to: 'To',
            next: 'Previous',
            searchPlan: 'Search plan',
            copy: 'Copy',
            reset: 'Reset',
            AllDay: 'AllDay',
            Monday: 'Monday',
            Tuesday: 'Tuesday',
            Wednesday: 'Wednesday',
            Thursday: 'Thursday',
            Friday: 'Friday',
            Saturday: 'Saturday',
            Sunday: 'Sunday',
            VideoPatrol: 'VideoPatrol',
            securityWorkGroupNames: 'SecurityworkGroup',
        },
        // 提示类
        placeholder: {
            selectStart: 'Select date time',
            noData: 'No Data',
            please: 'Please select',
            pleaseGroup: 'Please select responsibility group'
        },
        // 消息类
        message: {
            compare: 'The start time cannot be greater than the end time',
            writeRemark: 'Please fill in the remarks and submit the report',
            repairSuccess: 'The report was recorded successfully',
            reportRemark: 'Please enter remark',
            remarkValue: 'The length is between 0 and 200 characters',
            alarmLevel: 'Please select the alarm level',
            alarmType: 'Please select the alarm type',
            submitReportNo: 'Failed to submit report',
            submitReportYes: 'Report submitted successfully',
            hasTasked: 'The task has expired',
            startSuccess: 'Launch mission successful',
            noFinishedTask: 'Cannot initiate completed patrols!',
            startingTask: 'The patrol is on!',
            pastTask: 'The task has expired',
            pauseFail: 'The current patrol mission has failed to pause',
            numsPicture: 'Maximum upload 4 pictures',
            sizePicture: 'The picture format is not correct, please choose again',
            alarmSuccess: 'The alarm was reported successfully',
            patrolTime: 'Enter patrol duration',
            choseCamera: 'Please select a device',
            camerLen: 'The number of punches cannot be 0 or greater than the number of cameras',
            planName: 'Name cannot be empty',
            nameLen: 'Name is from 1 to 64 characters in length',
            nameInclude: 'Only includes letters,numbers,Chinese and underscores',
            chooseTime: 'Please select the patrol cycle',
            disabledNull: 'The number of punches cannot be empty',
            camerLens: 'The number of punches cannot be 0 or greater than the number of cameras',
            stopPlanWarn: 'This action deactivates plan and whether to continue?',
            planStop: 'Plan has been deactivated',
            cancelStop: 'Cancel the outage',
            startWarn: 'This action will enable plan and whether to continue?',
            planStart: 'The plan has been launched.',
            cancelUse: 'Cancel to enable',
            noRepeat: 'Do not repeat',
            modifyWarn: 'There is currently an ongoing task. The modification may affect the task. Does it continue?',
            createSucc: 'Created successfully',
            disabledModify: 'There are tasks under way in the plan and cannot be modified',
            modifyPlan: 'Modify plan',
            mnewPlan: 'New plan',
            planDetail: 'Plan details',
            modifyPlans: 'This action will permanently delete the patrol plan. Do you want to continue?',
            deleteWarn:'The patrol plan has an ongoing task. Do you want to continue deleting it?',
            deleteSucc:'successfully deleted',
            modifySucc:'Successfully modified',
            SuspendPatrolling: 'Suspend patrolling',
            VideoPlatform: 'Platform video start, stop patrol more',
            VideoPlatformFail: 'The current patrol mission has failed to pause',
            StartPatrolling: 'Began patrolling',
            stopVideoPlatform: 'Platform recording stopped, began patrol',
            startPatrolFail: 'Failed to start patrol mission',
            startVideo: 'Start the video',
            stopVideo: 'Stop the video',
            addressOk: 'Capture successful, default path',
            addressNo: 'Snap failure',
            ClockSuccess: 'Clock in success',
            ClockFail: 'Punching failure',
            GetVideoInfo: 'Getting more video info for current tour',
            SwitchVideoInfo: 'Switching to the next patrol video'
        },
        // 标题类
        title: {
            patrolDetail: 'PatrolDetail',
            pictureDetail: 'PictureDetail',
            alarmDetail: 'AlarmDetail',
            preview: 'Snapshot preview',
            system: 'Sysgen',
            hand: 'Hand',
            noCard: 'NoCard',
            yesCard: 'HasClock',
            history: 'Patrol history',
            noStart: 'Unstart',
            starting: 'Starting',
            pause: 'Paused',
            finish: 'Finished',
            All: 'All',
            patrolList: 'Patrol duty list',
            patrolReport: 'Patrol report',
            patrolWay: 'PatrolWay',
            choseArea: 'Select regional device',
            patrolTime: 'Patrol time',
            newBlock: 'New panel',
            chooseArea: 'Select device area',
            deviceDetail: 'Device details',
            deviceName: 'Device Name',
            lng: 'Longitude:',
            lat: 'Latitude:',
            planTime: 'Patrol plan list',
            searchs: 'Search',
            createPlan: 'Create new plan',
            liveBrowsing: 'Real-time video',
            second: 'Second',
            play: 'Play',
            photograph: 'Photograph',
            video: 'Video',
            stopVideo: 'StopVideo',
            punch: 'Punch',
            reportAlarm: 'ReportAlarm',
            submitReport: 'SubmitReport'
        }
    }
}